export const optionsCheckboxInput = [
  { value: 'reactjs', label: 'react js', disabled: false },
  { value: 'nodejs', label: 'node js', disabled: false },
  { value: 'postgres', label: 'postgres', disabled: true },
  {
    value: 'reactnative',
    label: 'react native',
    disabled: false,
  },
];

export const optionsRadioInput = [
  { value: 'yes', label: 'yes', disabled: false },
  { value: 'no', label: 'no', disabled: false },
  { value: 'maybe', label: 'maybe', disabled: true },
];

export const optionsSelectInput = [
  { value: 'sao paulo', label: 'são paulo' },
  { value: 'rio de janeiro', label: 'rio de janeiro' },
  { value: 'minas gerais', label: 'minas gerais' },
];
